import { Injectable } from '@angular/core';
import { HttpRepository } from "./http.repository";
import { GlobalConfig } from "../configs/GlobalConfig";
import { Observable } from 'rxjs';
import { Company } from "../interfaces/rest/Company";
import { HttpClient } from "@angular/common/http";
import {PagedData} from "../interfaces/rest/paging/PagedData";
import {PagingRequest} from "../interfaces/rest/paging/PagingRequest";
import {UserSessionRepository} from "./user-session.repository";
import {Filter} from "../interfaces/rest/paging/Filter";

@Injectable()
export class ClientRepository {

    constructor(protected http: HttpClient,
                protected httpRepository: HttpRepository,
                protected userSessionRepository: UserSessionRepository) {
    }

    /**
     * Get clients
     * @returns {Observable<Array<Company>>}
     */
    getClients(): Observable<Array<Company>> {
        return this.httpRepository.get(GlobalConfig.endpoints.clients);
    }

    getClientsWithPaging(pagingRequest: PagingRequest): Observable<PagedData> {
        return this.httpRepository.post(`${GlobalConfig.endpoints.clients}/paging`, pagingRequest);
    }

    getCurrentUserClientsWithPaging(pagingRequest: PagingRequest): Observable<PagedData> {
        let currentUser = this.userSessionRepository.getUserSession();
        if (currentUser!.userType === 'see') {
            return this.getClientsWithPaging(pagingRequest);
        } else {
            const newPagingRequest = new PagingRequest();
            newPagingRequest.pageSize = pagingRequest.pageSize;
            newPagingRequest.page = pagingRequest.page;
            newPagingRequest.sorts = pagingRequest.sorts;
            newPagingRequest.filters = ([] as Array<Filter>).concat(pagingRequest.filters);

            const filter = new Filter();
            filter.filterType = 'EQUAL';
            filter.filterValue = currentUser!.userId!.toString();
            filter.property = 'users.userId';
            newPagingRequest.filters.push(filter);
            return this.getClientsWithPaging(newPagingRequest);
        }
    }

    /**
     * Get clients by client ID.
     * @param {number} clientId
     * @returns {Observable<Company>}
     */
    getClient(clientId: number): Observable<Company> {
        return this.httpRepository.get(`${GlobalConfig.endpoints.clients}/${clientId}`);
    }


    /**
     * Create new client.
     * @param body
     * @returns {Observable<any>}
     */
    addClient(body: Company) {
        return this.httpRepository.post(GlobalConfig.endpoints.clients, body);
    }

    /**
     * Update existing client.
     * @param body
     * @param clientId
     * @returns {Observable<any>}
     */
    updateClient(body: Company, clientId: any) {
        return this.httpRepository.put(`${GlobalConfig.endpoints.clients}/${clientId}`, body);
    }

    cloneClient(targetClientId: any): Observable<Company> {
        let endpoint = `${GlobalConfig.endpoints.clients}/${targetClientId}/clone`;
        return this.httpRepository.post(endpoint, '');
    }
}
